export const TYPE_OF_ORDER_VALUES = {
  NEW_ORDER: "newOrder",
  ALREADY_EXISTING_ORDER: "alreadyExistingOrder",
};
